// extracted by mini-css-extract-plugin
export var card = "_lj-0";
export var content = "_lj-2";
export var details = "_lj-3";
export var icon = "_lj-1";
export var iconBlue = "_lj-5";
export var iconBrand = "_lj-4";
export var iconGrayBlue = "_lj-6";
export var iconGreen = "_lj-7";
export var iconIndigo = "_lj-8";
export var iconOrange = "_lj-9";
export var iconPurple = "_lj-a";
export var iconRed = "_lj-b";
export var iconWarning = "_lj-c";